module.exports = __webpack_public_path__ + "img/column.3a0247cd.png";